import Carousel, { ResponsiveType } from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useIsMobile } from 'utils/hooks';

interface MultiCarouselProps {
  items: JSX.Element[];
  responsiveObject: ResponsiveType;
  width: string;
}

// width cannot be a precentage
const MultiCarousel = ({ items, responsiveObject, width }: MultiCarouselProps) => {
  const isMobileView = useIsMobile();
  const carouselWidth = isMobileView ? '100%' : width;

  return (
    <div style={{ maxWidth: carouselWidth }} className="m-auto">
      <Carousel partialVisible responsive={responsiveObject}>
        {items}
      </Carousel>
    </div>
  );
};

export default MultiCarousel;
